export default "__VITE_ASSET__3efe964d__"